export const INVOICE_CREATE = 'invoiceCreate'
export const INVOICE_EDIT = 'invoiceEdit'
export const INVOICE_DELETE = 'invoiceDelete'
export const INVOICE_GET = 'invoiceGet'
export const INVOICES_GET = 'invoicesGet'
export const INVOICES_BM_GET = 'invoicesBMGet'
export const INVOICES_SIMPLE_BM_GET = 'invoicesSimpleBMGet'
export const INVOICE_SEARCH = 'invoiceSearch'
export const INVOICE_ACTIVE = 'invoiceActive'
export const INVOICE_INACTIVE = 'invoiceInactive'